var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shr-placeholder-loader"},[_c('div',{staticClass:"loader-card",class:_vm.customClass,style:({width: _vm.width, height: _vm.height, margin: _vm.margin})})])
}
var staticRenderFns = []

export { render, staticRenderFns }